import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8af0889c")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")

  return (_openBlock(), _createBlock(_component_swiper, {
    "space-between": 8,
    "slides-per-view": "auto",
    pagination: {
      dynamicBullets: true,
    },
    modules: $setup.modules,
    "free-mode": {
      momentumVelocityRatio: 0.5,
    }
  }, {
    default: _withId(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.banners, (banner) => {
        return (_openBlock(), _createBlock(_component_swiper_slide, {
          key: banner.id
        }, {
          default: _withId(() => [
            _createVNode("img", {
              class: "slide-content",
              src: `https://storage.googleapis.com/thelivery/img/banners/${banner.img}`,
              onClick: ($event: any) => ($options.goEstablishments(banner))
            }, null, 8, ["src", "onClick"])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }, 8, ["modules", "free-mode"]))
})